import { LimitBanner, LimitText } from "./styles";
import { SWReactIcons } from "@similarweb/icons";
import { useSelector } from "react-redux";
import { selectDashboardSegments, selectLimitationStatus } from "app/pages/dashboard/redux/selectors";
import { SEGMENTS_LIMIT_STATUS_MAP } from "app/pages/dashboard/constants";
import { Trans } from "@similarweb/i18n-provider";
import { swSettings } from "app/common/services/swSettings";

const SegmentsLimitBanner = () => {
    const segmentsLimitationStatus = useSelector(selectLimitationStatus);
    const dashboardSegments = useSelector(selectDashboardSegments);
    const { SegmentsPerDashboardHardLimit, SegmentsPerDashboardSoftLimit } = swSettings?.current?.resources;

    return (
        <LimitBanner>
            <SWReactIcons
                iconName={"segment-folder"}
                size={"sm"}
            />
            <LimitText>
                {segmentsLimitationStatus === SEGMENTS_LIMIT_STATUS_MAP.HARD_LIMIT ? <Trans
                        i18nKey="dashboard.segments.limitation.banner.hard.limit"
                        values={{
                            segmentsCount: dashboardSegments?.length,
                            limit: SegmentsPerDashboardHardLimit,
                        }}
                    /> : null}
                {segmentsLimitationStatus === SEGMENTS_LIMIT_STATUS_MAP.SOFT_LIMIT ? <Trans
                        i18nKey="dashboard.segments.limitation.banner.soft.limit"
                        values={{
                            limit: SegmentsPerDashboardSoftLimit,
                        }}
                    /> : null}
            </LimitText>
        </LimitBanner>
    );
};

export default SegmentsLimitBanner;
